export default "__VITE_ASSET__nBel8Fcb__"